import { colors } from '@material-ui/core';

const white = '#FFFFFF';
const black = '#000000';
const primaryBorder = '#0068FD99';

// Dark theme palette
export const darkPalette = {
  black,
  white,
  type: 'dark',
  primary: {
    contrastText: white,
    dark: colors.blue['A700'],
    main: colors.blue['A700'],
    light: colors.blue['A700']
  },
  secondary: {
    contrastText: white,
    dark: colors.blue['A400'],
    main: colors.blue['A400'],
    light: colors.blue['A400']
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400]
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400]
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400]
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400]
  },
  text: {
    primary: white,
    secondary: white,
    link: colors.blue[600]
  },
  background: {
    default: black,
    paper: black,
    primaryBorder,
    section: '#252C35FF',
    record: '#252C35FF'
  },
  icon: colors.blueGrey[600],
  divider: colors.grey[600]
};

// Light theme palette
export const lightPalette = {
  black,
  white,
  type: 'light',
  primary: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[700],
    light: colors.blue[500]
  },
  secondary: {
    contrastText: white,
    dark: colors.blue[700],
    main: colors.blue[500],
    light: colors.blue[300]
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400]
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400]
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400]
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400]
  },
  text: {
    primary: colors.grey[900],
    secondary: colors.grey[700],
    link: colors.blue[600]
  },
  background: {
    paper: white,
    primaryBorder,
    section: '#e3f2fd',
    record: '#fafafa'
  },
  icon: colors.blueGrey[600],
  divider: colors.grey[200]
};

// Export dark as default for backwards compatibility
export default darkPalette;
